/* ABRIS MTL unified Product Badge — one editor block in every Shopify page context.
   Never show a badge on an unverified product card. Each block is initially hidden
   to prevent flashes while Shopify loads or rerenders a section in the theme editor. */
class AbrisProductBadge extends HTMLElement {
  #rotationTimer;

  connectedCallback() {
    clearTimeout(this.#rotationTimer);
    const card = this.closest('product-card');
    const scope = String(this.dataset.displayScope || 'automatic');
    const pageType = String(this.dataset.pageType || '');
    const targetId = String(this.dataset.targetProductId || '').trim();
    const targetHandle = String(this.dataset.targetProductHandle || '').trim();
    let matched = false;

    if (card) {
      // Collection/recommendation cards: a badge MUST be explicitly assigned.
      const actualId = String(card.dataset.productId || '').trim();
      matched = this.dataset.allProductCards === 'true' || Boolean(targetId && actualId && targetId === actualId);
      if (!matched && targetHandle && this.dataset.allProductCards !== 'true') {
        const url = card.querySelector('a.product-card__link[href]')?.getAttribute('href') || '';
        const match = url.match(/\/products\/([^/?#]+)/);
        let handle = '';
        if (match) {
          try { handle = decodeURIComponent(match[1]); }
          catch { handle = match[1]; }
        }
        matched = Boolean(handle && handle === targetHandle);
      }
    } else {
      // Standalone badges: the theme editor placement itself selects the location.
      matched = true;
      if (scope === 'product_only' && pageType !== 'product') matched = false;
      if (scope === 'site_pages' && pageType === 'product') matched = false;
      if (scope === 'automatic' && pageType === 'product' && (targetId || targetHandle)) {
        const currentId = String(this.dataset.pageProductId || '').trim();
        // The selected product may not be resolved; fail closed if so.
        matched = Boolean(targetId && currentId && targetId === currentId);
      }
    }
    this.hidden = !matched;
    if (matched) this.#startRotation();
  }

  disconnectedCallback() {
    clearTimeout(this.#rotationTimer);
  }

  #startRotation() {
    const messages = Array.from(this.querySelectorAll('.product-activity__message'));
    messages.forEach((message, index) => {
      message.hidden = false;
      message.classList.toggle('is-active', index === 0);
    });
    if (messages.length < 2 || this.dataset.rotationEnabled !== 'true') return;

    const interval = Math.max(Number(this.dataset.rotationInterval) || 5000, 3000);
    const loop = this.dataset.rotationLoop === 'true';
    let index = 0;
    const advance = () => {
      if (!this.isConnected || this.hidden) return;
      if (!loop && index === messages.length - 1) return;
      index = (index + 1) % messages.length;
      messages.forEach((message, i) => message.classList.toggle('is-active', i === index));
      this.#rotationTimer = setTimeout(advance, interval);
    };
    this.#rotationTimer = setTimeout(advance, interval);
  }
}
if (!customElements.get('product-activity-badge')) {
  customElements.define('product-activity-badge', AbrisProductBadge);
}
